/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentApplicationResponse } from './TournamentApplicationResponse';
import {
    TournamentApplicationResponseFromJSON,
    TournamentApplicationResponseFromJSONTyped,
    TournamentApplicationResponseToJSON,
    TournamentApplicationResponseToJSONTyped,
} from './TournamentApplicationResponse';

/**
 * 
 * @export
 * @interface ValidateMatchPhotoResponse
 */
export interface ValidateMatchPhotoResponse {
    /**
     * Whether the photo was captured and recorded
     * @type {boolean}
     * @memberof ValidateMatchPhotoResponse
     */
    stored: boolean;
    /**
     * 
     * @type {TournamentApplicationResponse}
     * @memberof ValidateMatchPhotoResponse
     */
    tournamentApplication?: TournamentApplicationResponse;
}

/**
 * Check if a given object implements the ValidateMatchPhotoResponse interface.
 */
export function instanceOfValidateMatchPhotoResponse(value: object): value is ValidateMatchPhotoResponse {
    if (!('stored' in value) || value['stored'] === undefined) return false;
    return true;
}

export function ValidateMatchPhotoResponseFromJSON(json: any): ValidateMatchPhotoResponse {
    return ValidateMatchPhotoResponseFromJSONTyped(json, false);
}

export function ValidateMatchPhotoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateMatchPhotoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'stored': json['stored'],
        'tournamentApplication': json['tournamentApplication'] == null ? undefined : TournamentApplicationResponseFromJSON(json['tournamentApplication']),
    };
}

export function ValidateMatchPhotoResponseToJSON(json: any): ValidateMatchPhotoResponse {
    return ValidateMatchPhotoResponseToJSONTyped(json, false);
}

export function ValidateMatchPhotoResponseToJSONTyped(value?: ValidateMatchPhotoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stored': value['stored'],
        'tournamentApplication': TournamentApplicationResponseToJSON(value['tournamentApplication']),
    };
}

